<template>
  <div
    v-if="activityInfo"
    :class="[
      'pullNewHome',
      {
        inApp: $root.$data.isApp || this.$root.miniprogram,
        isPreview: this.$route.query.preview === '1',
      },
    ]"
    :style="{ background: 'url(' + activityInfo.activityBackgroundPicture + ') repeat' }"
  >
    <CommonTitle :titleName="activityInfo.activityName" />
    <Banner :activityInfo="activityInfo" />
    <Btn @click.native="createImg" />
    <Rule :activityRule="activityInfo.activityRule" />
    <PrizeList :activityInfo="activityInfo" />
    <Speed :activityInfo="activityInfo" />
    <CoursePull
      v-if="!(this.$root.ytMini || this.$root.pullNewType === 2) && productId"
      @coursePullCb="coursePullCb"
      :productId="productId"
      :productSkuId="productSkuId"
    />
    <Recommend :activityId="activityId" />
    <CanvasImg :activityInfo="activityInfo" ref="canvasImg" />
    <AppDown v-if="!(this.$root.ytMini || this.$root.pullNewType === 2)" />
    <ChatCommunity
      v-if="!(this.$root.ytMini || this.$root.pullNewType === 2) && chatCommunityShow"
      :productId="productId"
      :productSkuId="productSkuId"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getPullNewInfoApi } from '@/api/pullNew';
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { GetQueryValue, getRegisterSourceInfo } from '@/utils/tools';
import CanvasImg from '../components/canvasImg.vue';
import Banner from '../components/banner.vue';
import Rule from '../components/rule.vue';
import Speed from '../components/speed.vue';
import CoursePull from '../components/coursePull.vue';
import PrizeList from '../components/prizeList.vue';
import Btn from '../components/btn.vue';
import AppDown from '../components/appDown.vue';
import Recommend from '../components/recommends.vue';
import ChatCommunity from './../components/chat.vue';
import wx from 'weixin-js-sdk';

export default {
  components: {
    CanvasImg,
    CommonTitle,
    Banner,
    Rule,
    Speed,
    CoursePull,
    PrizeList,
    Btn,
    AppDown,
    Recommend,
    ChatCommunity,
  },
  data() {
    return {
      activityId: null,
      activityInfo: null,
      dataUrl: null, // 生成的图片URL
      canvasImgShow: false,
      productId: null,
      productSkuId: null,
      chatCommunityShow: false, // 页面悬浮挂件
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    $route() {
      window.scrollTo = 0;
      this.$router.go();
    },
  },
  methods: {
    async getActivityInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const info = await getPullNewInfoApi(this.activityId, this.$route.query.preview || 0);
      this.$toast.clear();
      const { code, data, msg } = info;
      if (code === 0) {
        this.activityInfo = data;
        this.productId = data.productId;
        this.productSkuId = data?.productSkuId;
        if (this.$root.ytMini || this.$root.pullNewType === 2) {
          document.title = '云图书吧';
        } else {
          document.title = data.activityName;
        }
        const { activityId, activityPicture, pullNewActivityShareData = {}, activityName } = data;
        const { encryptionKey } = pullNewActivityShareData;
        const path = encryptionKey
          ? `${
              window.location.origin
            }/ark/pullnew/helper/?activityId=${activityId}&key=${encryptionKey}&pullNewType=${
              this.$root.pullNewType === 2 ? 'yt' : ''
            }&miniSource=${this.$root.ytMini ? 'yt' : ''}`
          : `${window.location.origin}${
              window.location.pathname
            }?activityId=${activityId}&pullNewType=${
              this.$root.pullNewType === 2 ? 'yt' : ''
            }&miniSource=${this.$root.ytMini ? 'yt' : ''}`;
        this.wxInit(path, activityName, activityPicture);
      } else if (code === 9001 || code === 9002 || code === 9408) {
        // 未开始 已结束
        console.log(this.$route.query, 300000);
        this.$router.replace({
          path: '/pullnew/over',
          query: {
            activityId: this.activityId,
            activityStatus: code,
            broswerTime: GetQueryValue('broswerTime'),
            annexId: GetQueryValue('annexId'),
            luckDrawId: GetQueryValue('luckDrawId'),
            linkId: GetQueryValue('linkId'),
          },
        });
      } else {
        this.$toast.fail(msg);
      }
    },
    wxInit(path, title, imageUrl) {
      console.log('wxInit', path, title);
      wx.ready(() => {
        // 需在用户可能点击分享按钮前就先调用
        wx.miniProgram.postMessage({
          data: {
            path,
            title,
            imageUrl,
          },
        });
      });
    },
    createImg() {
      if (this.userInfo.id) {
        console.log(this.activityInfo.pullNewActivityShareData, '33333');
        if (this.$root.miniprogram) {
          const {
            activityId,
            activityName,
            activityPicture,
            activitySharePicture,
            activityBackgroundPicture,
            pullNewActivityShareData,
          } = this.activityInfo;
          const temps = {
            activityId,
            activityName,
            activityPicture,
            activitySharePicture,
            activityBackgroundPicture,
            encryptionKey: pullNewActivityShareData.encryptionKey,
          };
          const jsonString = JSON.stringify(temps);
          const encodedValue = encodeURIComponent(jsonString);
          console.log(temps, 'temps');
          console.log(jsonString, 'jsonString');
          console.log(encodedValue, 'encodedValue');
          this.$refs.canvasImg.pushShareStatus();
          wx.miniProgram.navigateTo({
            url: `/subPackages/pullNewShare/index?activityInfo=${encodedValue}`,
          });
        } else {
          this.$refs.canvasImg.createImg();
        }
      } else if (this.$root.$data.isApp) {
        getRegisterSourceInfo(this, 'pullnew/home', 1, false);
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        const params = searchParams.split('&');
        const paramsMap = new Map();

        params.forEach((item) => {
          const [key, value] = item.split('=');
          console.log('key', key, value);
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
        }
        url = `${domain}?${query}`;
        const redirctUrl = encodeURIComponent(
          `/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({
          path: '/registrationLogin',
          query: {
            redirect: path,
            loginSource: this.$root.pullNewType === 2 ? 'yuntulogin' : '',
            ...query,
          },
        });
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.getActivityInfo();
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 从CoursePull组件反馈过来的信息
    coursePullCb() {
      this.chatCommunityShow = true;
    },
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 获取登录状态
    setTimeout(() => {
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    if (this.$root.miniprogram) {
      gio('track', 'PageAccess_event', {
        beforePageName_var: this.$route.query.beforePageName==1?'我加入的活动':"热门活动",
        functionName_var: '活动详情',
        platform_var: '启航考研小程序',
      });
    }
  },
  created() {
    // localStorage.removeItem('accessToken');
    const { activityId } = this.$route.query;
    this.activityId = activityId;
    this.getActivityInfo();
  },
};
</script>
<style scoped lang="scss">
.pullNewHome {
  min-height: 100vh;
  padding: 100px 0 200px;

  &.inApp {
    padding-top: 0;
  }
}

.pullNewHome.isPreview {
  pointer-events: none;
}
</style>
